"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { NEW_TAB_NEXT_PARAM, isSafeInternalPath } from "@/lib/new-tab-history";

/**
 * Completes the "open in new tab with Back support" flow started by
 * `openInNewTabWithHistory`. Renders nothing.
 */
export const NewTabHistoryRedirect = () => {
  const router = useRouter();

  useEffect(() => {
    const url = new URL(window.location.href);
    const next = url.searchParams.get(NEW_TAB_NEXT_PARAM);
    if (!next) return;

    // Clean the origin entry so Back lands on the normal URL.
    url.searchParams.delete(NEW_TAB_NEXT_PARAM);
    window.history.replaceState(
      window.history.state,
      "",
      `${url.pathname}${url.search}${url.hash}`,
    );

    if (isSafeInternalPath(next)) router.push(next);
  }, [router]);

  return null;
};
